export const tooltips = {
  addressHeader: "Your address",
  addressBody: "Please enter your address",
};
